<template>
  <div class="projectCZJL">
    <el-form
      inline
      ref="form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="操作人员：">
            <el-input
              @change="getListData"
              size="mini"
              v-model.trim="form.operatorName"
              placeholder="请输入操作人员"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="操作时间：">
            <el-date-picker
              v-model="createTime"
              size="mini"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels
              clearable
              @change="getListData"
            ></el-date-picker>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <el-timeline>
      <el-timeline-item
        :timestamp="item.operatorTime"
        :key="item.id"
        placement="top"
        v-for="item in listData"
      >
        <el-card>
          <h4>{{ item.content }}</h4>
          <p>{{ item.operatorName }} 操作于 {{ item.operatorTime }}</p>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>
<script>
import { getOperatorLogList } from "@/api/salesManagement/detail";
export default {
  name: "projectCZJL",
  props: ["projectId"],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      form: {
        operatorName: "",
      },
      createTime: [],
      listData: [],
    };
  },
  methods: {
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.getListData();
    },
    handleSearch() {
      this.getListData();
    },
    async getListData() {
      const params = { ...this.form, projectId: this.projectId };
      if (this.createTime && this.createTime.length) {
        params.operatorTimeStart = this.createTime[0];
        params.operatorTimeEnd = this.createTime[1];
      } else {
        params.operatorTimeStart = "";
        params.operatorTimeEnd = "";
      }
      const res = await getOperatorLogList(params);
      if (res.code === 200) {
        this.listData = res.data;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.projectGZJD {
  &-choose,
  &-main {
    margin-top: 16px;
  }
  .el-upload-list {
    display: none;
  }
  .el-timeline-item {
    list-style-type: none;
  }
}
</style>
<style lang="scss">
.projectCZJL {
  max-height: 400px;
  overflow: auto;
}
</style>




// WEBPACK FOOTER //
// src/pages/salesManagement/xmgl/components/DetailProoject/czjl.vue